// import iphone from "../../assets/iphone-side.png";
import right from "../../assets/right.svg";
// import aboutImage from "../../assets/screens/3.png";
import "./style.css";
import { useEffect, useState } from "react";
// import Iphone from "./Iphone";
import iphone from "../../assets/iphone.png";
import screen from "../../assets/screens/1.png";
import { useLocation } from "react-router-dom";

const About = () => {
	const location = useLocation();
	const [data, setData] = useState([
		{
			label: "Creative design",
			description:
				"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra nunc ante velit vitae. Est tellus vitae, nullam lobortis enim. Faucibus amet etiam tincidunt rhoncus, ullamcorper velit.",
		},
		{
			label: "Creative design",
			description:
				"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra nunc ante velit vitae. Est tellus vitae, nullam lobortis enim. Faucibus amet etiam tincidunt rhoncus, ullamcorper velit.",
		},
		{
			label: "Creative design",
			description:
				"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra nunc ante velit vitae. Est tellus vitae, nullam lobortis enim. Faucibus amet etiam tincidunt rhoncus, ullamcorper velit.",
		},
	]);

	useEffect(() => {
		if (location.state?.scrollTo) {
			const element = document.getElementById(location.state.scrollTo);
			if (element) {
				element.scrollIntoView({ behavior: "smooth" });
			}
		}
	}, [location]);

	return (
		<div className="about" id="about">
			<div className="container">
				<p className="title">About Our App</p>
				<p className="description">
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra nunc
					ante velit vitae. Est tellus vitae, nullam lobortis enim. Faucibus
					amet etiam tincidunt rhoncus, ullamcorper velit. Ullamcorper risus
					tempor, ac nunc libero urna, feugiat.
				</p>
				<div className="about-data">
					<div className="row">
						<div className="col-md-6 col-12 d-flex justify-content-center justify-center-mobile">
							<div className="phone-head">
								<div className="phone">
									<img src={iphone} className="iphone" alt="iphone" />
									<img src={screen} className="screen" alt="screen" />
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="about-description">
								{data?.map((res, index) => {
									return (
										<div key={index} className="about-description-card">
											<img src={right} alt="right" />
											<div>
												<p className="title">{res?.label}</p>
												<p className="description">{res?.description}</p>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default About;
